class CalendarDay {
  isBlank = true
  date = null
  value = null
  initValue = null

  isChanged () {
    return this.value !== this.initValue
  }
}

export default CalendarDay
